module.exports = __webpack_public_path__ + "static/media/SkillsIcon.6928f904.svg";